import {lazy} from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'

export function DashboardRouter() {
    const DashboardAdministrative = lazy(
        () => import('../../pages/dashboard/DashboardAdministrative')
    )

    return (
        <Switch>
            <Route path='/dashboard/administrativo' component={DashboardAdministrative} />
            <Redirect exact from='/' to='/dashboard/administrativo' />
        </Switch>
    )
}
